import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  // useNavigate,
  // useLocation,
} from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { UserProvider } from './contexts/UserContext';
import { LeagueProvider } from './contexts/LeagueContext';
import { ZoomProvider } from './contexts/ZoomContext';
import PrivateRoute from './components/PrivateRoute';
import Navigation from './components/Navigation';
import ZoomableContent from './components/ZoomableContent';
import TitleUpdater from './components/TitleUpdater';
import EnvironmentIndicator from './components/EnvironmentIndicator';
// import LoadingSpinner from './components/LoadingSpinner';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ForgotPassword from './pages/ForgotPassword';
//import RoundEntry from './pages/RoundEntry';
//import LeagueView from './pages/LeagueView';
import CourseView from './pages/CourseView';
import CourseSearchView from './pages/CourseSearchView';
import Profile from './pages/Profile';
import UpdatePassword from './pages/UpdatePassword';
import UpdateEmail from './pages/UpdateEmail';
import LoadingTest from './pages/LoadingTest';
import Home from './pages/Home';
//import StartRound from './pages/StartRound';
import HoleEntry from './pages/HoleEntry';
import CourseScorecard from './pages/CourseScorecard';
import RoundScorecard from './pages/RoundScorecard';
import StartLeagueRound from './pages/StartLeagueRound';
import ScoresOnly from './pages/ScoresOnly';
import LeagueResults from './pages/LeagueResults';
import LeagueAdmin from './pages/LeagueAdmin';
import LeagueReports from './pages/LeagueReports';

// Layout component that includes Navigation
const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
    }}>
      <Navigation />
      <ZoomableContent>
        {children}
      </ZoomableContent>
    </div>
  );
};

const App: React.FC = () => {

  return (
    <Router>
      <AuthProvider>
        <UserProvider>
          <LeagueProvider>
            <ThemeProvider>
              <ZoomProvider>
                <TitleUpdater />
                <EnvironmentIndicator />
                <Layout>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/loading" element={<LoadingTest />} />
                    <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                    <Route path="/dashboard/:dayId" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                    {/* <Route path="/round/:roundId" element={<PrivateRoute><RoundEntry /></PrivateRoute>} /> */}
                    {/* <Route path="/league/:leagueId" element={<PrivateRoute><LeagueView /></PrivateRoute>} /> */}
                    <Route path="/course/:courseId" element={<PrivateRoute><CourseView /></PrivateRoute>} />
                    <Route path="/courses" element={<PrivateRoute><CourseSearchView /></PrivateRoute>} />
                    <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
                    <Route path="/update-password" element={<PrivateRoute><UpdatePassword /></PrivateRoute>} />
                    <Route path="/update-email" element={<PrivateRoute><UpdateEmail /></PrivateRoute>} />
                    {/* <Route path="/start-round" element={<PrivateRoute><StartRound /></PrivateRoute>} />
                    <Route path="/start-round/:step" element={<PrivateRoute><StartRound /></PrivateRoute>} /> */}
                    <Route path="/league/:leagueId/start-round/:courseId/:dayId" element={<PrivateRoute><StartLeagueRound /></PrivateRoute>} />
                    <Route path="/hole-entry" element={<PrivateRoute><HoleEntry /></PrivateRoute>} />
                    <Route path="/hole-entry/:courseId/:roundId/:holeNumber" element={<PrivateRoute><HoleEntry /></PrivateRoute>} />
                    <Route path="/course-scorecard/:courseId" element={<PrivateRoute><CourseScorecard /></PrivateRoute>} />
                    {/* <Route path="/round-summary/:roundId" element={<PrivateRoute><RoundSummary /></PrivateRoute>} /> */}
                    <Route path="/round-scorecard" element={<PrivateRoute><RoundScorecard /></PrivateRoute>} />
                    <Route path="/round-scorecard/:courseId/:roundId" element={<PrivateRoute><RoundScorecard /></PrivateRoute>} />
                    <Route path="/scores-only-entry/:courseId/:roundId" element={<PrivateRoute><ScoresOnly /></PrivateRoute>} />
                    <Route path="/league-results/:leagueId_dayId" element={<PrivateRoute><LeagueResults /></PrivateRoute>} />
                    <Route path="/league-results/:leagueId_dayId/:flightId" element={<PrivateRoute><LeagueResults /></PrivateRoute>} />
                    <Route path="/league/:leagueId/admin" element={<PrivateRoute><LeagueAdmin /></PrivateRoute>} />
                    <Route path="/league-reports/:leagueId" element={<PrivateRoute><LeagueReports /></PrivateRoute>} />
                  </Routes>
                </Layout>
              </ZoomProvider>
            </ThemeProvider>
          </LeagueProvider>
        </UserProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
